/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const ZaloNotificationSettingUpdate = lazyLoad(
  () => import('./index'),
  module => module.ZaloNotificationSettingUpdate
);
